import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField,
  FormGroup,
  FormControl,
  Typography,
  Link,
  Card,
  CardContent,
  Grid,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  LinearProgress,
  Popper,
  Box,
  Paper,
  Autocomplete,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import * as Yup from 'yup';
import './styles.css';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';
import {
  LocalizationProvider,
  DatePicker,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/pt';
import brLocale from 'date-fns/locale/pt-BR';
import DateFnsUtils from '@date-io/date-fns';
import deLocale from 'date-fns/locale/pt-BR';
import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import { useStyles } from '../../components/Styles';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import GroupButton from '../../components/Buttons/ButtonGroup';
import AutocompleteParameters from '../../components/AutocompleteParameters';
import HandleParameters from '../../components/handleParameters';
import { TooltipInfo } from 'components/tooltips/tooltipsInfo';
import styleGlobal from '../../Global.module.css';
import InfoIcon from '@mui/icons-material/Info';
import FormDialogContent from '../measurement/formDialog/formDialogContent';
import { POND_STATUS_CYCLE, parameterTypes } from 'utils/consts';
import { labelField } from 'utils';

function Biomeasure() {
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle,
  );
  const location = useLocation();
  const [locale, setLocale] = React.useState('pt');

  const [selectedForm, handleForm] = useState('');
  const [pondCycles, setPondCycles] = useState([]);
  const [selectedPondCycle, handlePondCycle] = useState(null);
  const [parameters, setParameters] = useState([]);
  const [selectedParameters, setSelectedParameters] = useState([]);
  const [samples, setSamples] = useState([]);
  const [forms, setForms] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const parametersIsNull = useState(false);
  const [openPondModal, setOpenPondModal] = useState(false);
  const [openLinearProgress, setOpenLinearProgress] = useState(false);
  const [openAutocomplete, setOpenAutocomplete] = useState(false);
  const classes = useStyles();
  const history = useHistory();
  let { id } = useParams();
  const dispatch = useDispatch();
  const [selectedDate, handleDateChange] = useState(new Date());
  const disable = useSelector((state) => state.disable.disable);
  const notIsFirstAccess = useSelector(
    (state) => state.notIsFirstAccess.notIsFirstAccess,
  );
  const error = Error();
  const success = Success();

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.id;
        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    formik.setValues(data);

    handlePondCycle(data.cycle);
    handleForm(parseInt(data.form));

    setSelectedParameters(data.parameters.map((value) => value.parameter));

    const parametersFormateds = data.parameters;
    setSamples(parametersFormateds);
    formik.setFieldValue('parameters', parametersFormateds);

    handleDateChange(new Date(data.get_at));
  }

  function updateSamples(options) {
    formik.setFieldValue('parameters', options);
  }

  useEffect(() => {
    setOpenProgress(true);

    api.get(`/cycles/cycle-code/${selectedCycle.id}`).then((pondCycles_) => {
      setPondCycles(
        pondCycles_.data.filter(
          (pond) => pond.status === POND_STATUS_CYCLE.CULTIVANDO || pond.status === POND_STATUS_CYCLE.PREPARANDO,
        ),
      );
    });
    api.get('/parameters').then((parameters_) => setParameters(
      parameters_.data
        .filter((parameter) => parameter.type === 'Animal')
        .map((parameter) => ({
          ...parameter,
          parameter_id: parameter.id,
          description: '',
        })),
    ));
    api.get('/forms').then((forms_) => {
      // setForms(forms_.data.filter(form => form.type === "Animal"))
      setForms(
        forms_.data.filter(
          (form) => form.isActive === true && form.type === 'Animal',
        ),
      );
    });
    setOpenProgress(false);
  }, [selectedCycle]);

  async function request(data) {
    // envia os dados para api salvar no banco
    dispatch(setDisable(true));
    if (!id) {
      data.parameters.forEach((item) => {
        item.parameter_id = item.id;
        delete item.id;
      });
    }

    try {
      id
        ? await api.put(`/biomeasures/${id}`, { ...data })
        : await api.post('/biomeasures', { ...data });
      success();
      history.push('/biomeasures');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      value: '',
      size: '',
      cycle: '',
      get_at: '',
    },
    validationSchema: Yup.object({
      cycle: Yup.number().required('Campo Obrigatório'),
      size: Yup.number()
        .required('Campo Obrigatório')
        .min(0, 'Precisa ser acima de 0')
        .max(
          999999999,
          'Valor máximo ultrapassado. Diminua o tamanho da amostra',
        )
        .typeError(
          'O valor deve ser um número. Caso seja um número decimal utilize " . " ao invés de " , "',
        ),
    }),
    onSubmit: (values) => {
      if (values.parameters.length === 0) {
        parametersIsNull[1](true);
        return false;
      }
      dispatch(setLoading(true));
      values.get_at = selectedDate.toUTCString();
      values.cycle = selectedPondCycle.id;
      values.form = selectedForm ? selectedForm.id : null;
      request(values);
    },
  });

  useEffect(() => {
    formik.values.cycle = selectedPondCycle?.id;
  }, [selectedPondCycle]);

  function handleParameters(parameters) {
    // if(parameters)
    setSelectedParameters(parameters);
  }

  useEffect(() => {
    if (selectedParameters && !id) {
      setSamples(selectedParameters);
      formik.setFieldValue('parameters', selectedParameters);
    }
  }, [selectedParameters]);

  useEffect(() => {
    // Carrega os dados na tabela de cadastro
    if (selectedForm) {
      if (selectedForm.parameters !== undefined) {
        const parametersFormateds = selectedForm.parameters.map((parameter) => ({
          ...parameter.parameter,
          id: parameter.parameter_id,
          parameter_id: parameter.parameter_id,
        }));

        setSelectedParameters(parametersFormateds);

        setSamples(parametersFormateds);
        formik.setFieldValue('parameters', parametersFormateds);
        // setar imagens
      }
    }
  }, [selectedForm, id]);

  /**
* @param {React.ChangeEvent<{}>} event
* @param {AutocompleteChangeReason} reason
*/
  const handleCloseModal = (event, reason) => {
    if (reason === 'backdropClick') {
      setOpenPondModal(false);
    }
    if (reason === 'escapeKeyDown') {
      setOpenPondModal(false);
    }
  };

  // Estilização do tooltip
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 400,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  return (
    <header className={styleGlobal.headerGlobal}>
      {openProgress ? <Progress /> : null}
      {' '}
      <Card style={{ padding: '2rem', borderRadius: '20px' }}>
        {/** Carregamento circular para o carregamento dos dados */}
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.root}>
            <h2 style={{ marginBottom: '2rem' }}>
              Dados da Biometria
              {' '}
              <HtmlTooltip
                title={(
                  <>
                    Nessa tela é possível fazer o acompanhamento dos parâmetros dos animais,  principalmente seu peso. É possível calcular a massa adquirida durante um período de tempo, analisar o desenvolvimento do animal, entre outras coisas.
                  </>
                )}
                placement="right"
                arrow
                interactive
              >
                <InfoIcon color="primary" fontSize="inherit" />
              </HtmlTooltip>
            </h2>

            <CardContent style={{ padding: '0rem' }}>
              <Grid container spacing={2}>
                <Dialog
                  style={{ padding: '15rem' }}
                  open={openPondModal}
                  fullWidth
                  maxWidth="lg"
                  onClose={handleCloseModal}
                >
                  {openLinearProgress && <LinearProgress />}
                  <DialogTitle style={{ paddingBottom: '0' }}>
                    <span style={{ paddingLeft: '1rem' }}>
                      Dados do Formulário
                    </span>
                  </DialogTitle>
                  <DialogContent>
                    <FormDialogContent
                      setForms={(data) => {
                        const filteredByMeasurement = data.filter((item) => item.type.includes('Animal'));
                        setForms(filteredByMeasurement);
                      }}
                      typeName="Animal"
                      setOpenPondModal={setOpenPondModal}
                      setOpenAutocomplete={setOpenAutocomplete}
                      setOpenLinearProgress={setOpenLinearProgress}
                    />
                  </DialogContent>
                </Dialog>
                <Grid item xs={12} sm={6}>
                  <FormGroup>
                    <Autocomplete
                      noOptionsText={(
                        <Typography>
                          Nenhum viveiro configurado para esse ciclo.
                          <Link
                            style={{ marginLeft: '1%', cursor: 'pointer' }}
                            color="primary"
                            onMouseDown={() => {
                              history.push(
                                notIsFirstAccess ? '/first-cycle' : '/cycle',
                              );
                            }}
                          >
                            Configurar agora +
                          </Link>
                        </Typography>
                      )}
                      name="cycle"
                      options={pondCycles}
                      value={selectedPondCycle}
                      getOptionLabel={(options) => options.pond.description}
                      onChange={(p, v) => {
                        handlePondCycle(v);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={labelField('Viveiro')}
                          variant="outlined"
                          onBlur={formik.handleBlur}
                          error={formik.touched.cycle && formik.errors.cycle}
                          helperText={
                            formik.touched.cycle && formik.errors.cycle
                          }
                        />
                      )}
                    />
                  </FormGroup>
                </Grid>
                {!id && (
                  <Grid item xs={12} sm={6}>
                    <FormGroup>
                      <Autocomplete
                        open={openAutocomplete}
                        onOpen={() => {
                          setOpenAutocomplete((state) => !state);
                        }}
                        onClose={() => {
                          setOpenAutocomplete((state) => !state);
                        }}
                        noOptionsText={false}
                        name="form"
                        options={forms}
                        value={selectedForm}
                        getOptionLabel={(options) => (typeof options === 'string' ? options : options.name)}
                        onChange={(p, v) => {
                          handleForm(v);
                        }}
                        onBlur={formik.handleBlur}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Formulário (opcional)"
                            variant="outlined"
                          // disabled={id?true:false}
                          />
                        )}
                        PopperComponent={(param) => (
                          <Popper {...param}>
                            <Box {...param} />
                            <Paper style={{ height: '100%' }}>
                              <Typography
                                style={{ padding: '1rem', color: 'gray' }}
                              >
                                {forms.length === 0
                                  ? 'Não existe formulário cadastrado nessa medição.'
                                  : 'Deseja cadastrar outro formulário?'}
                                {' '}
                                <Link
                                  style={{ cursor: 'pointer' }}
                                  color="primary"
                                  onMouseDown={() => {
                                    setOpenPondModal((state) => !state);
                                  }}
                                >
                                  Cadastrar Formulário +
                                </Link>
                              </Typography>
                            </Paper>
                          </Popper>
                        )}
                      />
                    </FormGroup>
                  </Grid>
                )}

                {!id && (
                  <Grid item xs={12} sm={6}>
                    <AutocompleteParameters
                      type={parameterTypes.ANIMAL}
                      form_id={null}
                      parameters={selectedParameters}
                      options={parameters}
                      callback={handleParameters}
                      parametersIsNull={parametersIsNull}
                    />
                  </Grid>
                )}

                <Grid item xs={12} sm={3}>
                  <FormGroup>
                    <TextField
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="size"
                      label={labelField('Tamanho da amostra')}
                      variant="outlined"
                      name="size"
                      type="number"
                      value={formik.values.size}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={!!(formik.touched.size && formik.errors.size)}
                      helperText={
                        formik.touched.size
                        && formik.errors.size
                        && formik.errors.size
                      }
                    />
                  </FormGroup>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormGroup>
                    <LocalizationProvider
                      adapterLocale={deLocale}
                      dateAdapter={DateFnsUtils}
                    >
                      <DatePicker
                        InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                        label={<div>Data</div>}
                        name="get_at"
                        variant="inline"
                        inputVariant="outlined"
                        invalidDateMessage="Data Inválida"
                        value={selectedDate}
                        onChange={(get_at) => handleDateChange(get_at)}
                        onBlur={formik.handleBlur}
                        // inputFormat="DD/MM/YYYY"
                        format="dd/MM/yyyy"
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </FormGroup>
                </Grid>
              </Grid>
              <h3 className="titleb">Parâmetros</h3>
              <FormGroup>
                <FormControl>
                  <HandleParameters
                    label="Valor Médio"
                    parameters={samples}
                    samples={samples}
                    // dataOfImages
                    id={id}
                    callback={updateSamples}
                  >
                    {' '}
                  </HandleParameters>
                </FormControl>
              </FormGroup>
            </CardContent>
          </div>
          {/* <FormGroup>
                        <Autocomplete
                            noOptionsText="Sem opções"
                            fullWidth
                            multiple
                            id='worker'
                            options={workers}
                            value={selectedWorkers}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.name}
                            renderOption={(option, { selected }) => (
                                <React.Fragment>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.name}
                                </React.Fragment>
                            )}
                            onChange={(_, v) => {
                                setSelectedWorkers(v)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant='outlined'
                                    label='Funcionários'
                                    placeholder='Funcionários'
                                />
                            )}
                        />
                    </FormGroup> */}
          <GroupButton
            deleteRoute="/biomeasures/"
            routeDelete="/biomeasures"
            returnRoute="/biomeasures"
            id={id}
            disable={disable}
            message="A exclusão dessa biometria pode levar a exclusão de objetos que dependam dela. Tem certeza que deseja excluir?"
          />
        </form>
      </Card>
    </header>
  );
}

export default Biomeasure;
